import { useState, useEffect } from 'react';

const CAMPAIGN_END = new Date('2026-03-31T23:59:59+09:00');

export default function CampaignHero() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calc = () => {
      const diff = CAMPAIGN_END.getTime() - Date.now();
      if (diff <= 0) {
        setIsExpired(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    calc();
    const t = setInterval(calc, 1000);
    return () => clearInterval(t);
  }, []);

  const timerUnits = [
    { value: timeLeft.days, label: '日' },
    { value: timeLeft.hours, label: '時間' },
    { value: timeLeft.minutes, label: '分' },
    { value: timeLeft.seconds, label: '秒' },
  ];

  return (
    <section className="relative min-h-[85svh] flex items-center justify-center overflow-hidden" aria-labelledby="campaign-hero-heading">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/87ea1077668c2babe779954f2bbf7ae6.jpg"
          alt="新生活応援キャンペーン背景"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 text-center py-32 sm:py-40">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full mb-6 sm:mb-8 border border-white/20">
          <span className="text-lg" aria-hidden="true">🌸</span>
          <span className="text-xs sm:text-sm font-light text-white tracking-[0.15em]">期間限定キャンペーン</span>
        </div>

        <h1 id="campaign-hero-heading" className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.08em]">
          新生活応援キャンペーン
        </h1>
        <p className="text-base sm:text-lg md:text-xl font-extralight text-white/90 mb-3 sm:mb-4 tracking-wide max-w-2xl mx-auto">
          4月の次回入荷までの価格維持購入予約
        </p>
        <p className="text-sm sm:text-base font-extralight text-white/70 mb-10 sm:mb-14 tracking-wide max-w-3xl mx-auto">
          2026年3月1日より価格改定となりますが、3月31日までのご予約で現行価格を維持いたします。
        </p>

        {/* Countdown Timer */}
        {!isExpired ? (
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-white/10 backdrop-blur-md rounded-2xl px-6 sm:px-10 py-5 sm:py-6 border border-white/15">
            <span className="text-white/60 text-xs sm:text-sm font-light tracking-wide mr-2 hidden sm:inline">終了まで</span>
            {timerUnits.map((unit, idx) => (
              <div key={unit.label} className="flex items-center gap-2 sm:gap-3">
                <div className="flex flex-col items-center min-w-[48px] sm:min-w-[60px]">
                  <span className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white leading-none tracking-tight">
                    {String(unit.value).padStart(2, '0')}
                  </span>
                  <span className="text-[10px] sm:text-xs text-white/50 mt-1 font-light">{unit.label}</span>
                </div>
                {idx < timerUnits.length - 1 && (
                  <span className="text-white/30 text-xl sm:text-2xl font-extralight -mt-3">:</span>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="inline-flex items-center gap-2 px-6 py-4 bg-white/10 backdrop-blur-md rounded-2xl border border-white/15">
            <span className="text-white/80 text-sm sm:text-base font-light tracking-wide">キャンペーンは終了しました</span>
          </div>
        )}

        {/* Scroll hint */}
        <div className="mt-12 sm:mt-16 animate-bounce">
          <a href="#price-context" className="inline-flex flex-col items-center text-white/50 hover:text-white/80 transition-colors cursor-pointer" aria-label="価格改定の背景へスクロール">
            <span className="text-xs font-light tracking-widest mb-2">SCROLL</span>
            <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
